if (!customElements.get('collection-cart-opener')) {
  customElements.define(
    'collection-cart-opener',
    class CollectionCartOpener extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
      }

      connectedCallback() {
        this.button = this.querySelector('button');
        this.cartDrawer = document.querySelector('cart-drawer');
        this.button?.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onClick);
      }

      onClick() {
        this.cartDrawer?.open(this.button);
      }
    }
  );
}
